import React, { useState, useEffect } from 'react';
import api from '../api';
import DishCard from '../components/DishCard';

function useIsMobile() {
  const [v, setV] = useState(window.innerWidth < 768);
  useEffect(() => {
    const fn = () => setV(window.innerWidth < 768);
    window.addEventListener('resize', fn);
    return () => window.removeEventListener('resize', fn);
  }, []);
  return v;
}

export const BarPage = () => {
  const [dishes, setDishes] = useState([]);
  const [loading, setLoading] = useState(true);
  const isMobile = useIsMobile();
  const [gridKey, setGridKey] = useState(0);
  const [activeTab, setActiveTab] = useState('all');

  useEffect(() => {
    api.get('/dishes')
      .then(r => setDishes(r.data))
      .catch(() => setDishes([]))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    const handleLikeUpdate = () => setGridKey(k => k + 1);
    window.addEventListener('likeUpdated', handleLikeUpdate);
    return () => window.removeEventListener('likeUpdated', handleLikeUpdate);
  }, []);

  const barDishes = dishes.filter(d => ['9', '10'].includes(String(d.category_id)));

  const filteredDishes = barDishes.filter(d => {
    if (activeTab === 'all') return true;
    if (activeTab === 'alco') return String(d.category_id) === '9';
    if (activeTab === 'nonalco') return String(d.category_id) === '10';
    return true;
  });

  return (
    <div className="page-enter" style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <div style={{
        background: '#0d0d0b',
        padding: isMobile ? '22px 20px 20px' : '32px 40px 28px',
        flexShrink: 0, position: 'relative', overflow: 'hidden',
      }}>
        <div style={{ position: 'absolute', right: -20, top: -20, width: 160, height: 160, borderRadius: '50%', border: '1px solid rgba(255,255,255,0.06)', pointerEvents: 'none' }} />

        <div style={{ fontSize: 10, letterSpacing: '2.5px', textTransform: 'uppercase', color: '#c8b89a', marginBottom: 10, fontWeight: 300 }}>
          Авторські напої
        </div>
        
        <div style={{ fontFamily: "'Fraunces', serif", fontSize: isMobile ? 32 : 42, color: '#fff', lineHeight: 1.1, fontWeight: 300 }}>
          Бар <span style={{ 
            fontStyle: 'italic', 
            fontWeight: 600,
            background: 'linear-gradient(90deg, #F9E79F 0%, #D4AF37 50%, #F9E79F 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            textShadow: '0 4px 20px rgba(212, 175, 55, 0.4)',
            display: 'inline-block',
            paddingRight: '5px' 
          }}>Lentochka</span>
        </div>
        
        <div style={{ fontSize: 13, color: 'rgba(255,255,255,0.45)', marginTop: 8, fontWeight: 300 }}>
          Коктейлі · Вино · Безалкогольні
        </div>
      </div>

      <div style={{
        display: 'flex', gap: 10, overflowX: 'auto', flexShrink: 0,
        padding: isMobile ? '16px 16px 0' : '20px 28px 0',
        scrollbarWidth: 'none', WebkitOverflowScrolling: 'touch'
      }}>
        {[
          { id: 'all', label: 'Всі напої' },
          { id: 'alco', label: '🥂 Алкогольні' },
          { id: 'nonalco', label: '🥤 Безалкогольні' },
        ].map(tab => {
          const isActive = activeTab === tab.id;
          return (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              style={{
                padding: isMobile ? '10px 18px' : '12px 22px', 
                borderRadius: 30,
                border: isActive ? '1px solid transparent' : '1px solid #e8ddd0',
                background: isActive ? 'linear-gradient(135deg, #2a2a2a 0%, #0d0d0b 100%)' : '#fff',
                color: isActive ? '#e8c97e' : '#8c857d',
                fontWeight: isActive ? 600 : 500,
                fontSize: isMobile ? 13 : 14,
                cursor: 'pointer', whiteSpace: 'nowrap',
                boxShadow: isActive ? '0 6px 16px rgba(0,0,0,0.15)' : '0 2px 6px rgba(0,0,0,0.02)',
                transition: 'all 0.25s ease'
              }}
              onMouseEnter={e => {
                if (!isActive) {
                  e.currentTarget.style.background = '#faf7f3';
                  e.currentTarget.style.borderColor = '#d4af37';
                  e.currentTarget.style.color = '#0d0d0b';
                }
              }}
              onMouseLeave={e => {
                if (!isActive) {
                  e.currentTarget.style.background = '#fff';
                  e.currentTarget.style.borderColor = '#e8ddd0';
                  e.currentTarget.style.color = '#8c857d';
                }
              }}
            >
              {tab.label}
            </button>
          );
        })}
      </div>

      <div key={gridKey} style={{
        flex: 1, overflowY: 'auto',
        padding: isMobile ? '16px 16px 24px' : '24px 28px 32px',
      }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fill, minmax(260px, 1fr))',
          gap: isMobile ? 12 : 16,
        }}>
          {loading ? (
            <div style={{ textAlign: 'center', padding: '40px 0', color: '#8c857d', gridColumn: '1/-1' }}>
              Завантаження бару...
            </div>
          ) : filteredDishes.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '60px 20px', color: '#8c857d', fontSize: 14, gridColumn: '1/-1' }}>
              <div style={{ fontSize: 48, marginBottom: 16 }}>🍸</div>
              <div style={{ fontFamily: "'Fraunces', serif", fontSize: 20, color: '#0d0d0b', marginBottom: 8 }}>
                Барне меню оновлюється
              </div>
              <div>Скоро тут з'являться найкращі напої</div>
            </div>
          ) : (
            filteredDishes.map(dish => <DishCard key={dish.id} dish={dish} />)
          )}
        </div>
      </div>
    </div>
  );
};
